import 'core-js'
import './sass/style.scss'

import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import router from './router'
import App from './App.vue'

Vue.config.productionTip = false

if (process.env.NODE_ENV === 'production') {
    Sentry.init({ dsn: 'https://99de08b75473455e8ca0e1402a92d013@sentry.io/1413823' })
}

const app = new Vue({
    router,
    render: (h) => h(App),
})

app.$mount('#app')
